import { styled } from '@mui/material'
import { preventForwardProp } from 'utils/styledUtils'
import { IPostCard } from './BlogCard/types'

export const ContentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '1280px',
  marginLeft: 'auto',
  marginRight: 'auto',
  alignItems: 'start',
  [theme.breakpoints.up('xs')]: {
    padding: theme.spacing(0, 2),
  },
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 3),
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    padding: theme.spacing(0, 8),
    gap: theme.spacing(9),
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(0, 10),
    gap: theme.spacing(13.5),
  },
  [theme.breakpoints.up('xl')]: {
    padding: 0,
    gap: theme.spacing(15.5),
  },
}))

export const PostsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  columnGap: '12px',
  rowGap: theme.spacing(6),
  width: '100%',
  marginBottom: theme.spacing(12),
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}))

export const CardContainer = styled(
  'div',
  preventForwardProp('featured'),
)<IPostCard>(({ theme, featured }) => ({
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    padding: featured ? 0 : theme.spacing(0, 8.75),
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: featured ? 'span 2' : 'span 1',
    padding: 0,
  },
}))

export const PaginationContainer = styled('div')(({ theme }) => ({
  gridColumn: 'span 1',
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 8.75),
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: 'span 2',
    padding: 0,
  },
}))

export const SidebarContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  flexShrink: 0,
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 8.75),
  },
  [theme.breakpoints.up('md')]: {
    width: '316px',
    padding: 0,
  },
}))
